<template>
  <section class="section">
    <b-loading
      :is-full-page="true"
      :active.sync="isLoading"
      :can-cancel="false"
    ></b-loading>
    <S3AvatarPicker />
    <update-password-form @formSubmit="submitUpdatePassword" />
  </section>
</template>

<script>
import { Auth } from 'aws-amplify'

import UpdatePasswordForm from '@/components/common/settings/UpdatePasswordForm'
import S3AvatarPicker from '@/components/common/S3AvatarPicker.vue'

export default {
  components: { UpdatePasswordForm, S3AvatarPicker },
  name: 'AdminProfile',
  mixins: [],
  props: {},
  data() {
    return {
      isLoading: false
    }
  },
  computed: {},
  methods: {
    submitUpdatePassword(formData) {
      let self = this
      self.isLoading = true
      Auth.currentAuthenticatedUser()
        .then(user => {
          return Auth.changePassword(
            user,
            formData.oldPassword,
            formData.newPassword
          )
        })
        .then(() =>
          self.$toast.open({
            message: self.$t('Contraseña actualizada'),
            type: 'success',
            duration: 5000
          })
        )
        .catch(err =>
          self.$toast.open({
            message: err.message,
            type: 'error',
            duration: 5000
          })
        )
        .then(() => (self.isLoading = false))
    }
  },
  mounted() {}
}
</script>
